import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import { navShoppingGuideUrl } from '@/mocks/articles';
import Button from '@/components/base/Button';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 shadow-sm backdrop-blur-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a href="/" className="flex items-center gap-2">
            <span className="text-lg md:text-xl font-heading font-bold text-foreground-900">
              Kakobuy <span className="text-primary-500">Spreadsheet</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-3">
            <a href="/" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
              {t('nav.home')}
            </a>
            <a href={navShoppingGuideUrl} className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
              {t('nav.shoppingGuide')}
            </a>
            <a href="/artykul/kakobuy-spreadsheet-poradnik" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">
              {t('nav.blog')}
            </a>
            <div className="flex items-center gap-2 ml-3">
              <Button variant="outline" href="https://kaspreadsheet.com">
                {t('nav.kakobuySpreadsheet')}
              </Button>
              <Button variant="primary" href="https://kaspreadsheet.com">
                {t('nav.buyItNow')}
              </Button>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 flex flex-col gap-1 bg-white/95 backdrop-blur-sm rounded-b-lg max-h-[70vh] overflow-y-auto">
            <a href="/" className="px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-50 rounded-md flex items-center gap-2" onClick={() => setMobileOpen(false)}>
              <i className="ri-home-4-line text-base"></i> {t('nav.home')}
            </a>
            <a href={navShoppingGuideUrl} className="px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-50 rounded-md flex items-center gap-2" onClick={() => setMobileOpen(false)}>
              <i className="ri-book-open-line text-base"></i> {t('nav.shoppingGuide')}
            </a>
            <a href="/artykul/kakobuy-spreadsheet-poradnik" className="px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-50 rounded-md flex items-center gap-2" onClick={() => setMobileOpen(false)}>
              <i className="ri-article-line text-base"></i> {t('nav.blog')}
            </a>

            <div className="border-t border-background-200 my-1 mx-4"></div>
            <p className="px-4 py-1 text-xs text-foreground-400 font-medium uppercase tracking-wider">{t('nav.categories')}</p>

            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 text-sm text-foreground-600 hover:text-primary-500 hover:bg-background-50 rounded-md flex items-center gap-2"
                onClick={() => setMobileOpen(false)}
              >
                <span className="w-6 h-6 flex items-center justify-center bg-background-100 rounded text-xs">
                  <i className="ri-arrow-right-up-line text-accent-500"></i>
                </span>
                {cat.namePl}
              </a>
            ))}

            <div className="border-t border-background-200 my-1 mx-4"></div>
            <div className="flex flex-col gap-2 px-4 pt-1">
              <Button variant="outline" href="https://kaspreadsheet.com" className="w-full justify-center">
                {t('nav.kakobuySpreadsheet')}
              </Button>
              <Button variant="primary" href="https://kaspreadsheet.com" className="w-full justify-center">
                {t('nav.buyItNow')}
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}